import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LanguageService } from '@core/services/language.service';

@Pipe({
    name: 'localDate',
    pure: false,
})
export class LocalDatePipe implements PipeTransform {

    constructor(private languageService: LanguageService) {}

    transform(value: string|Date|null|undefined, format: string): any {
        if (value === undefined || value === null) {
            return null;
        }

        if (typeof value === 'string') {
            if (value.length === 0) {
                return null;
            }

            value = new Date(value);
        }

        if (isNaN((value as Date).getTime())) {
            return null;
        }

        const datePipe = new DatePipe(this.languageService.currentLang.code);
        return datePipe.transform(value, format);
    }

}
